import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IconComponent } from '../icon';

export interface ActionCardData {
  title: string;
  description: string;
  icon: string;
  link: string;
  variant?: 'primary' | 'secondary';
  comingSoon?: boolean; // Adicionado à interface opcionalmente
}

@Component({
  selector: 'app-action-card',
  standalone: true,
  imports: [CommonModule, RouterModule, IconComponent],
  template: `
    <a
      [routerLink]="comingSoon ? null : link"
      [class]="getContainerClasses()"
    >
      <span *ngIf="comingSoon" class="absolute top-4 right-4 bg-gray-200 text-gray-600 text-xs font-semibold px-2.5 py-0.5 rounded border border-gray-300 z-10">
        Em breve
      </span>

      <app-icon
        [name]="icon"
        [className]="getIconClasses()"
      ></app-icon>
      
      <h3 [class]="getTitleClasses()">
        {{ title }}
      </h3>
      
      <p [class]="getDescriptionClasses()">
        {{ description }}
      </p>
    </a>
  `,
})
export class ActionCardComponent {
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() icon: string = '';
  @Input() link: string = '';
  @Input() variant: 'primary' | 'secondary' = 'secondary';
  @Input() comingSoon: boolean = false; // Nova propriedade

  getContainerClasses(): string {
    const baseClasses = 'block rounded-lg p-6 relative transition-all border';
    
    if (this.comingSoon) {
      return `${baseClasses} bg-gray-50 border-gray-200 opacity-75 cursor-not-allowed`;
    }

    if (this.variant === 'primary') {
      return `${baseClasses} bg-gradient-to-br from-[#4A90E2] to-[#2c5f8d] border-transparent text-white hover:shadow-lg`;
    }

    // Secondary (Default)
    return `${baseClasses} bg-white border-gray-200 hover:shadow-lg`;
  }

  getIconClasses(): string {
    const size = 'w-8 h-8 mb-3';
    
    if (this.comingSoon) return `${size} text-gray-400`;
    if (this.variant === 'primary') return size; // Ícone herda cor do texto (white)
    
    return `${size} text-[#4A90E2]`;
  }

  getTitleClasses(): string {
    const base = 'text-lg font-semibold mb-1';
    
    if (this.comingSoon) return `${base} text-gray-700`;
    if (this.variant === 'primary') return `${base} text-white`;
    
    return `${base} text-gray-900`;
  }

  getDescriptionClasses(): string {
    const base = 'text-sm';
    
    if (this.comingSoon) return `${base} text-gray-500`;
    if (this.variant === 'primary') return `${base} text-white/80`;
    
    return `${base} text-gray-500`;
  }
}